export default __webpack_public_path__ + "static/media/3bestfriend.a92687dd.mp3";